

export enum InvoiceStepState
{
    Preparing = "Preparing",
    Sent = "Sent"
}
